// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__KZLp4","modal":"styles_modal__UA93F","icon":"styles_icon__23bhQ"};